<template lang="pug">
#modal-header-planilha
    el-dialog.modal-header-planilha-content(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='50%'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.relatorioRastreabilidade.cadastro.informarRastreabilidadeMassa') }}

        .modal-header-planilha-content__container
            .container-header
                .modal-header-planilha-content__container__infor
                    span {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.texto') }}
                        <br> {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.textoQuebralinha')}}

                .modal-header-planilha-content__container__infor__lista
                    ul
                        li.obrigatorio {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.finca') }}
                        li.obrigatorio {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.volume') }}
                        li.obrigatorio(v-if='!isRastreabilidadeOffline') {{ $t(this.usuarioLogado.ambienteLogado === 'PY' ? 'RUC' : 'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.documento') }}
                        li(v-else) {{ $t(this.usuarioLogado.ambienteLogado === 'PY' ? 'RUC' : 'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.documento') }}

                .modal-header-planilha-content__container__infor__campos
                    p {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.vincularCampos') }}
                    .modal-header-planilha-content__container__infor__campos__vincular
                        .header
                            span.header-planilha {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.camposImportados') }}
                            span.header-rastreabilidade {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.camposRastreabilidade') }}

                        .campos(
                            v-for='(cabecalho, index) in dados',
                            :key='index',
                            :class='{ "campo--tracejado": index % 2 === 0 }'
                        )
                            span.campos-planilha {{ cabecalho }}
                            span.campos-rastreabilidade
                                el-select(
                                    v-model='campoRastreabilidadeObrigatorio[cabecalho]',
                                    :placeholder='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.selecione")',
                                    clearable,
                                    :disabled='carregando',
                                    @clear='handleClear(cabecalho)'
                                )
                                    el-option(
                                        v-for='campo in camposRastreabilidade',
                                        :key='campo.codigo',
                                        :label='campo.nome',
                                        :value='campo.nome',
                                        :disabled='campoRastreabilidadeJaSelecionado(campo.nome)'
                                    )

        footer.footer-modal-header.my-3(slot='footer')
            el-button(@click='fecharModal', :disabled='carregando')
                | {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.voltar') }}
            div(v-if='!verificarSelecao')
                el-tooltip(
                    effect='dark',
                    :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.relacionaCamposConfirmar")',
                    placement='top'
                )
                    el-button(type='primary', :disabled='!verificarSelecao')
                        | {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.processarVinculo') }}
            div(v-else)
                el-button(
                    type='primary',
                    @click='processarVinculo',
                    :loading='carregando',
                    :icon='carregando ? "el-icon-loading" : ""'
                )
                    | {{ carregando ? '' : this.$t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.processarVinculo') }}
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'ModalHeaderRastreabilidadeEmMassaPlanilha',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        dados: {
            type: Array,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        },
        isRastreabilidadeOffline: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            camposRastreabilidade: [],
            campoRastreabilidadeObrigatorio: {}
        };
    },

    watch: {
        show: function () {
            if (!this.show) return;
            this.resetModal();
        },
        usuarioLogado: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.camposRastreabilidade = [
                        {
                            nome:
                                newValue.ambienteLogado === 'PY'
                                    ? this.$t(
                                          'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.finca'
                                      )
                                    : 'CAR',
                            codigo:
                                newValue.ambienteLogado === 'PY'
                                    ? 'FINCA_PADRON'
                                    : 'CAR'
                        },
                        {
                            nome:
                                newValue.ambienteLogado === 'PY'
                                    ? 'RUC'
                                    : 'CPF/CNPJ',
                            codigo:
                                newValue.ambienteLogado === 'PY'
                                    ? 'RUC'
                                    : 'CPF_CNPJ'
                        },
                        {
                            nome: this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.volume'
                            ),
                            codigo: 'VOLUME'
                        }
                    ];
                }
            }
        }
    },

    computed: {
        verificarSelecao() {
            return (
                Object.keys(this.campoRastreabilidadeObrigatorio).length ===
                this.camposRastreabilidade.length
            );
        },
        ...mapState(['usuarioLogado'])
    },

    methods: {
        resetModal() {
            this.campoRastreabilidadeObrigatorio = {};
        },

        fecharModal() {
            if (this.carregando) {
                return;
            }
            try {
                this.$messageBox
                    .confirm(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.retornarTelaAnterior'
                        ),
                        this.$t(
                            'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.aviso'
                        ),
                        {
                            confirmButtonText: this.$t(
                                'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.confirmar'
                            ),
                            cancelButtonText: this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.subempresaInserirdadoscontratoplanilha.permanecer'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.$emit('voltar');
                    })
                    .catch(() => {});
            } catch (erro) {}
        },
        campoRastreabilidadeJaSelecionado(opcao) {
            for (const chave in this.campoRastreabilidadeObrigatorio) {
                if (
                    this.campoRastreabilidadeObrigatorio.hasOwnProperty(chave)
                ) {
                    if (this.campoRastreabilidadeObrigatorio[chave] === '') {
                        delete this.campoRastreabilidadeObrigatorio[chave];
                    } else if (
                        this.campoRastreabilidadeObrigatorio[chave] === opcao
                    ) {
                        return true;
                    }
                }
            }
            return false;
        },
        handleClear(cabecalho) {
            this.$delete(this.campoRastreabilidadeObrigatorio, cabecalho);
        },
        processarVinculo() {
            if (this.verificarSelecao) {
                if (this.carregando) return;
                this.$emit(
                    'processarVinculo',
                    this.campoRastreabilidadeObrigatorio
                );
            }
        }
    }
};
</script>

<style lang="scss">
#modal-header-planilha {
    footer {
        display: flex;
        justify-content: space-between;
    }
}
.modal-header-planilha-content {
    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: var(--primary) !important;
        color: var(--white);
        padding-bottom: 12px;
        padding-top: 12px;
    }
    .el-dialog__body {
        padding: 20px 20px 30px 20px;
        word-break: break-word;
    }
    .el-dialog__headerbtn {
        top: 10px;
    }
    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }
    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;
    }

    .modal-header-planilha-content__container {
        .modal-header-planilha-content__container__infor {
            margin-bottom: 8px;
        }
        .modal-header-planilha-content__container__infor__lista {
            ul {
                font-weight: bold;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }

        .obrigatorio::after {
            content: ' *';
            color: #f56c6c;
        }
        .modal-header-planilha-content__container__infor__campos {
            p {
                color: #656565;
                font-weight: bold;
            }
            .modal-header-planilha-content__container__infor__campos__vincular {
                display: flex;
                flex-direction: column;
                width: 100%;
                align-items: center;
                justify-content: space-between;
                box-shadow: 0px 1px 7px 0px var(--block-shadow);
                border-radius: 3px;

                .header {
                    background: #f7f7f7;
                    min-height: 45px;
                    color: #606266;
                    font-weight: bold;
                    border-bottom: 1px solid #d8d8d8;
                }
                .campos {
                    min-height: 33px;
                    &.campo--tracejado {
                        background-color: #f3f3f3;
                    }
                }

                .header,
                .campos {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    gap: 5px;
                    align-items: center;
                    padding: 5px;
                    padding-left: 15px;
                }
                .header .header-planilha,
                .header .header-rastreabilidade,
                .campos .campos-planilha,
                .campos .campos-rastreabilidade {
                    width: 50%;
                }
                .campos-rastreabilidade {
                    .el-select {
                        width: 90% !important;
                    }
                }
            }
        }
    }

    .footer-modal-header {
        .el-button {
            min-width: 153px;
        }
    }
}
</style>
